import svgxhr from '@pmpepper/webpack-svgstore/dist/helpers/svgxhr';

export default function loadIcons(path: string) {
    if (path && (typeof process.env.NODE_ENV == 'undefined' || process.env.NODE_ENV !== 'test')) {
        svgxhr(path);
    }
}
